module.exports = __webpack_public_path__ + "img/facilities-icon-3.5cfbab21.svg";